export const headers = [
    {
        text: 'Cliente',
        sortable: true,
        value: 'clientName'
    },
    {
        text: 'Veículo',
        sortable: true,
        value: 'plate'
    },
    {
        text: 'Data de criação',
        sortable: true,
        value: 'createdDate'
    },
    {
        text: 'Custo',
        sortable: true,
        value: 'hadCost',
    },
    {
        text: 'Descrição',
        sortable: true,
        value: 'description'
    },
    {
        text: 'Equipamentos',
        sortable: false,
        value: 'equipments'
    },
    {
        text: 'Isolado',
        align: 'start',
        sortable: true,
        width: '5%',
        value: 'isolated',
    },
    {
        text: 'Criado Por',
        sortable: true,
        value: 'account',
    },
    {
        text: 'Ação',
        sortable: false,
        value: 'actions',
    }
]